import Vue from 'vue';

export const submitRatingRequest = async ({
  session,
  uniqueOrderNumber,
  tipsQrCardHash,
  reviewId,
  rating,
  paymentUuid,
}) => {
  return await Vue.axios.post(`${process.env.VUE_APP_API_URL}reviews/rate-v2`, {
    session_token: session,
    unique_order_number: uniqueOrderNumber,
    tips_qr_card_hash: tipsQrCardHash,
    review_id: reviewId,
    payment_uuid: paymentUuid,
    rating,
  });
};

export const submitGreetRatingRequest = async ({
  session,
  uniqueOrderNumber,
  tipsQrCardHash,
  reviewId,
  rating,
}) => {
  return await Vue.axios.post(
    `${process.env.VUE_APP_API_URL}platform-reviews/rate`,
    {
      session_token: session,
      unique_order_number: uniqueOrderNumber,
      tips_qr_card_hash: tipsQrCardHash,
      platform_review_uuid: reviewId,
      rating,
    }
  );
};

export const submitRatingTagsRequest = async ({
  session,
  uniqueOrderNumber,
  tipsQrCardHash,
  reviewId,
  tags,
  paymentUuid,
}) => {
  return await Vue.axios.post(
    `${process.env.VUE_APP_API_URL}reviews/add-review-tags-v2`,
    {
      session_token: session,
      unique_order_number: uniqueOrderNumber,
      tips_qr_card_hash: tipsQrCardHash,
      review_id: reviewId,
      tags,
      payment_uuid: paymentUuid,
    }
  );
};

export const submitGreetRatingTagsRequest = async ({
  session,
  reviewId,
  tags,
}) => {
  return await Vue.axios.post(
    `${process.env.VUE_APP_API_URL}platform-reviews/add-review-tags`,
    {
      session_token: session,
      platform_review_uuid: reviewId,
      tags,
    }
  );
};

export const submitRatingCommentRequest = async ({
  session,
  uniqueOrderNumber,
  tipsQrCardHash,
  reviewId,
  comment,
  email,
  phoneNumber,
  paymentUuid,
}) => {
  return await Vue.axios.post(
    `${process.env.VUE_APP_API_URL}reviews/leave-comment-v2`,
    {
      session_token: session,
      unique_order_number: uniqueOrderNumber,
      tips_qr_card_hash: tipsQrCardHash,
      review_id: reviewId,
      comment,
      email,
      phone_number: phoneNumber,
      payment_uuid: paymentUuid,
    }
  );
};

export const submitGreetRatingCommentRequest = async ({
  session,
  reviewId,
  comment,
}) => {
  return await Vue.axios.post(
    `${process.env.VUE_APP_API_URL}platform-reviews/leave-comment`,
    {
      session_token: session,
      platform_review_uuid: reviewId,
      comment,
      phone_number: undefined,
      email: undefined,
    }
  );
};

export const submitAttemptToRateOnGoogleRequest = async ({
  session,
  uniqueOrderNumber,
  tipsQrCardHash,
  reviewId,
}) => {
  return await Vue.axios.post(
    `${process.env.VUE_APP_API_URL}reviews/mark-google-review-attempted-v2`,
    {
      session_token: session,
      unique_order_number: uniqueOrderNumber,
      tips_qr_card_hash: tipsQrCardHash,
      review_id: reviewId,
    }
  );
};
